module.exports = __webpack_public_path__ + "static/media/profile.79ac82a4.jpg";